import React from 'react';
import { useSelector } from 'react-redux';
import FilterModule from '../../modules/Filter';
import TaskListModule from '../../modules/TaskList';
import TestEditorModule from '../../modules/TestEditor';

const EditTestPage = () => {
	const state = useSelector((state) => state);

	return (
		state.editor?.test && (
			<>
				<FilterModule />
				<TaskListModule />
				<TestEditorModule mode="edit" />
			</>
		)
	);
};

export default EditTestPage;
